<script>
import {PolarArea, mixins} from 'vue-chartjs'
import {mapGetters} from "vuex";

const {reactiveProp} = mixins
export default {
  extends: PolarArea,
  mixins: [reactiveProp],
  props: ['options'],
  computed: {
    ...mapGetters('space', ['spaceCurrency']),
    ...mapGetters('cabinet/currencies', ['displayCurrencyValue']),
  },
  data() {
    return {
      legend: null
    }
  },
  methods: {
    createLegendBlock() {
      //initial of separated legend block
      let legendBlock = document.createElement('div');
      legendBlock.id = 'chartjs-legend-' + this.$el.querySelector('canvas').id;
      legendBlock.innerHTML = ""
      this.$el.parentElement.appendChild(legendBlock);
      this.legend = legendBlock;
    },
    updateDataset: function (e, datasetIndex) {
      //handle legend click to hide/display data
      let index = datasetIndex;
      let ci = this.$data._chart;
      let meta = ci.getDatasetMeta(0);
      let result = (meta.data[datasetIndex].hidden !== true);
      if (result === true) {
        meta.data[datasetIndex].hidden = true;
        document.getElementById(e.path[0].id).style.textDecoration = "line-through"
      } else {
        document.getElementById(e.path[0].id).style.textDecoration = ""
        meta.data[datasetIndex].hidden = false;
      }
      ci.update();
    },
    legendCallback: function (chart) {
      // Return the HTML string here.
      let text = [];
      text.push('<div class="' + chart.id + '-legend flex flex-wrap justify-center">');
      for (let i = 0; i < chart.data.datasets[0].data.length; i++) {
        let bg = chart.data.datasets[0].backgroundColor[i],
            label = chart.data.labels[i] ? chart.data.labels[i] : '';
        text.push(`<div id="legend-${chart.id}-item-${i}" class="legend-item ml-3 mb-1 text-textColor text-11px flex items-center">` +
            `<span class="block rounded-full w-3 h-3 mr-3" style="background-color:${bg}"></span>` +
            `${label}` +
            `</div>`)
      }
      text.push('</div>');
      return text.join("");
    }
  },
  mounted() {
    // this.createLegendBlock()
    this.renderChart(this.chartData, {
      legend: {
        display: false
      },
      layout: {
        padding: {
          left: 15,
          right: 15,
          top: 15,
          bottom: 15
        }
      },
      tooltips: {
        // callbacks: {
        //     label: (tooltipItem, data) => {
        //         const index = tooltipItem.index,
        //             tooltip_data = data.datasets[0].data[index],
        //             tooltip_label = data.labels[index]
        //         return `${tooltip_label}: ${this.spaceMoneyFormat(tooltip_data)}`;
        //     }
        // },
        enabled: false,
        custom: (tooltipModel) => {
          // Tooltip Element
          const chart_tooltip_id = 'chartjs-tooltip-' + this.$data._chart.canvas.id;
          let tooltipEl = document.getElementById(chart_tooltip_id);
          // Create element on first render
          if (!tooltipEl) {
            tooltipEl = document.createElement('div');
            tooltipEl.id = chart_tooltip_id;
            tooltipEl.classList.add('chartjs-tooltip');
            tooltipEl.innerHTML = "<table></table>"
            this.$data._chart.canvas.parentElement.appendChild(tooltipEl);
          }

          // Hide if no tooltip
          if (tooltipModel.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
          }

          // Set caret Position
          tooltipEl.classList.remove('above', 'below', 'no-transform');
          if (tooltipModel.yAlign) {
            tooltipEl.classList.add(tooltipModel.yAlign);
          } else {
            tooltipEl.classList.add('no-transform');
          }

          function getBody(bodyItem) {
            return bodyItem.lines;
          }

          // Set Text
          if (tooltipModel.body) {
            let titleLines = tooltipModel.title || [];
            let bodyLines = tooltipModel.body.map(getBody);

            let innerHtml = '<thead>';

            titleLines.forEach(function (title) {
              innerHtml += '<tr><th>' + title + '</th></tr>';
            });
            innerHtml += '</thead><tbody>';

            bodyLines.forEach((body, i) => {
              let colors = tooltipModel.labelColors[i],
                  style = 'background:' + colors.backgroundColor;
              style += '; border-color:' + colors.borderColor;
              style += '; border-width: 1px';
              let span = '<span class="chartjs-tooltip-key" style="' + style + '"></span>',
                  label = body[0].split(':')[0],
                  value = body[0].split(':')[1];
              innerHtml += `<tr><td>${span}${label}: ${this.displayCurrencyValue(+value, this.spaceCurrency)}</td></tr>`;
            });
            innerHtml += '</tbody>';

            let tableRoot = tooltipEl.querySelector('table');
            tableRoot.innerHTML = innerHtml;
          }

          let positionY = this.$data._chart.canvas.offsetTop;
          let positionX = this.$data._chart.canvas.offsetLeft;

          // Display, position, and set styles for font
          tooltipEl.style.opacity = 1;
          tooltipEl.style.left = positionX + tooltipModel.caretX + 'px';
          tooltipEl.style.top = positionY + tooltipModel.caretY + 'px';
          tooltipEl.style.fontSize = '12px';
          tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
        }
      },
      maintainAspectRatio: false,
      responsive: true,
      // legendCallback: this.legendCallback
    })
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        // this.legend.innerHTML = this.generateLegend();

        // @click="this.updateDataset(event, ' + '\'' + i + '\'' + ')"
        // this.legend.querySelectorAll('div .legend-item').forEach((item, index) => {
        //     item.addEventListener('click', (event) => {
        //         this.updateDataset(event, index)
        //     });
        // })
      }
    }
  }
}
</script>